/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import LoginComponent from './site-login';
import { isUserLoggedIn } from 'state/current-user/selectors';

export const login = (context, next) => {
    const userLoggedIn = isUserLoggedIn(context.store.getState());

    if (userLoggedIn) {
       window.location = '/';
        return;
    }

    context.primary = <LoginComponent />;
    next();
};

